import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/device-maintenance/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/device-maintenance/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/device-maintenance/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/device-maintenance/select/page',
    method: 'post',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/device-maintenance/delete/ids',
    method: 'post',
    params: {
      ids
    }
  })
}

